"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioPreviewEvent = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../BaseAvroRecord");
class AudioPreviewEvent extends BaseAvroRecord_1.BaseAvroRecord {
    constructor() {
        super(...arguments);
        this.stockItemContext = null;
        this.drawerType = null;
    }
    schema() {
        return AudioPreviewEvent.schema;
    }
    subject() {
        return AudioPreviewEvent.subject;
    }
}
exports.AudioPreviewEvent = AudioPreviewEvent;
AudioPreviewEvent.subject = "audio-preview-event";
AudioPreviewEvent.schema = {
    "type": "record",
    "name": "AudioPreviewEvent",
    "namespace": "storyblocks.content",
    "fields": [
        {
            "name": "meta",
            "type": {
                "type": "record",
                "name": "Meta",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "uuid",
                        "type": "string"
                    },
                    {
                        "name": "emitted",
                        "type": {
                            "type": "long",
                            "logicalType": "timestamp-millis"
                        }
                    },
                    {
                        "name": "origin",
                        "type": {
                            "type": "enum",
                            "name": "Origin",
                            "symbols": [
                                "VIDEOBLOCKS",
                                "AUDIOBLOCKS",
                                "GRAPHICSTOCK",
                                "STORYBLOCKS",
                                "STORYBLOCKS_NEXTJS",
                                "CONTRIBUTOR_PORTAL",
                                "TEMPLATE_EDITOR",
                                "ACCOUNT_SERVICE",
                                "BILLING_SERVICE",
                                "CONTENT_SERVICE",
                                "PAYOUT_SERVICE",
                                "TRANSLATION_SERVICE",
                                "CONTENT_RATING_APP",
                                "FEATURE_FLAG_SERVICE",
                                "PREMIERE_PRO_PLUGIN",
                                "AFTER_EFFECTS_PLUGIN",
                                "EXAMPLE_SERVICE",
                                "SEARCH_SERVICE",
                                "CONTENT_JOB",
                                "DATA_JOB",
                                "MISC",
                                "STORYBOARD",
                                "USER_SERVICE",
                                "SUBSCRIPTION_SERVICE",
                                "OUTDATED_SCHEMA"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "trace",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "TraceContext",
                                "fields": [
                                    {
                                        "name": "traceId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "pageTraceId",
                                        "type": "string",
                                        "default": ""
                                    },
                                    {
                                        "name": "spanId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "parentId",
                                        "type": "string",
                                        "default": ""
                                    }
                                ]
                            }
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "user",
            "type": {
                "type": "record",
                "name": "User",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "visitorCookieId",
                        "type": [
                            "null",
                            "string"
                        ]
                    },
                    {
                        "name": "userId",
                        "type": [
                            "null",
                            "int"
                        ]
                    },
                    {
                        "name": "subscriptionId",
                        "type": [
                            "null",
                            "int"
                        ]
                    },
                    {
                        "name": "recurlySubscriptionId",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    },
                    {
                        "name": "recurlySubscriptionUuid",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    },
                    {
                        "name": "organizationId",
                        "type": [
                            "null",
                            "int"
                        ],
                        "default": null
                    },
                    {
                        "name": "bot",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "Bot",
                                "fields": [
                                    {
                                        "name": "isBot",
                                        "type": "boolean"
                                    }
                                ]
                            }
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "urls",
            "type": {
                "type": "record",
                "name": "Urls",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "currentUrl",
                        "type": "string"
                    },
                    {
                        "name": "referrerUrl",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "device",
            "type": {
                "type": "record",
                "name": "Device",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "browser",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "Browser",
                                "namespace": "storyblocks.common.frontend",
                                "fields": [
                                    {
                                        "name": "userAgent",
                                        "type": "string"
                                    },
                                    {
                                        "name": "language",
                                        "type": "string"
                                    },
                                    {
                                        "name": "platform",
                                        "type": "string"
                                    },
                                    {
                                        "name": "name",
                                        "type": [
                                            "null",
                                            "string"
                                        ],
                                        "default": null
                                    }
                                ]
                            }
                        ],
                        "default": null
                    },
                    {
                        "name": "tab",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "Tab",
                                "namespace": "storyblocks.common.frontend",
                                "fields": [
                                    {
                                        "name": "isNewTab",
                                        "type": "boolean"
                                    },
                                    {
                                        "name": "tabCount",
                                        "type": "int"
                                    },
                                    {
                                        "name": "tabId",
                                        "type": "string"
                                    }
                                ]
                            }
                        ],
                        "default": null
                    },
                    {
                        "name": "navigation",
                        "type": {
                            "type": "record",
                            "name": "Navigation",
                            "namespace": "storyblocks.common.frontend",
                            "fields": [
                                {
                                    "name": "referrerUrl",
                                    "type": "string"
                                },
                                {
                                    "name": "navigationType",
                                    "type": [
                                        "null",
                                        {
                                            "type": "enum",
                                            "name": "NavigationType",
                                            "namespace": "storyblocks.common.enums",
                                            "symbols": [
                                                "TYPE_NAVIGATE",
                                                "TYPE_RELOAD",
                                                "TYPE_BACK_FORWARD",
                                                "TYPE_RESERVED",
                                                "OUTDATED_SCHEMA"
                                            ],
                                            "default": "OUTDATED_SCHEMA"
                                        }
                                    ],
                                    "default": null
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "name": "searchIdentifiers",
            "type": {
                "type": "record",
                "name": "SearchIdentifiers",
                "namespace": "storyblocks.search.records",
                "fields": [
                    {
                        "name": "searchId",
                        "type": "string",
                        "doc": "f.k.a. SSLID"
                    },
                    {
                        "name": "searchPageId",
                        "type": "string",
                        "doc": "f.k.a. SGUID"
                    },
                    {
                        "name": "lastSearchId",
                        "type": [
                            "null",
                            "string"
                        ],
                        "doc": "Previous searchId",
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "stockItem",
            "type": {
                "type": "record",
                "name": "ShallowStockItem",
                "namespace": "storyblocks.content.records",
                "fields": [
                    {
                        "name": "stockItemId",
                        "type": "int"
                    },
                    {
                        "name": "contentId",
                        "type": [
                            "null",
                            "int"
                        ],
                        "default": null
                    },
                    {
                        "name": "title",
                        "type": "string"
                    },
                    {
                        "name": "distributionType",
                        "type": {
                            "type": "enum",
                            "name": "DistributionType",
                            "namespace": "storyblocks.content.enums",
                            "symbols": [
                                "MEMBER_LIBRARY",
                                "REV_SHARE",
                                "MARKETPLACE",
                                "OUTDATED_SCHEMA"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "publishedDate",
                        "type": {
                            "type": "long",
                            "logicalType": "timestamp-millis"
                        }
                    },
                    {
                        "name": "distributionTypeUpdatedDate",
                        "type": [
                            "null",
                            {
                                "type": "long",
                                "logicalType": "timestamp-millis"
                            }
                        ],
                        "default": null
                    },
                    {
                        "name": "contentType",
                        "type": {
                            "type": "enum",
                            "name": "ContentType",
                            "namespace": "storyblocks.content.enums",
                            "symbols": [
                                "ALL",
                                "LOOPS",
                                "MUSIC",
                                "SOUND_EFFECTS",
                                "ILLUSTRATIONS",
                                "PHOTOS",
                                "SNAPSHOTS",
                                "VECTORS",
                                "FOOTAGE",
                                "MOTION_BACKGROUNDS",
                                "TEMPLATES",
                                "VR_360",
                                "OUTDATED_SCHEMA"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "format",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    },
                    {
                        "name": "thumbnailUrl",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "durationMs",
            "type": "int"
        },
        {
            "name": "playStartMs",
            "type": "int",
            "doc": "Relative to the beginning of the track."
        },
        {
            "name": "playEndMs",
            "type": "int",
            "doc": "Relative to the beginning of the track."
        },
        {
            "name": "stockItemContext",
            "type": [
                "null",
                "string"
            ],
            "default": null
        },
        {
            "name": "drawerType",
            "type": [
                "null",
                "string"
            ],
            "default": null
        }
    ]
};
//# sourceMappingURL=AudioPreviewEvent.js.map